var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlotoDropdownPicker',_vm._b({attrs:{"value":_vm.value,"search-fn":_vm.searchFolders,"disabled":_vm.disabled,"multiple":_vm.multiple,"as-input":"","immediate-search":"","transform-options-fn":_vm.transformFolder},on:{"change":function($event){return _vm.$emit('change', $event)}}},'FlotoDropdownPicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }